// HeroSection.js
import React, { useEffect, useState } from "react";
import SocialLinks from "../modules/SocialLinks";
import { Fade } from "react-awesome-reveal";


const HeroSection = () => {
	const images = [
		"murtaza-lightwala-headshot",
		"murtaza-lightwala-professional-photo",
		"murtaza-lightwala-portrait",
	];

	const imagesAlt = [
		"Murtaza Lightwala - Professional Headshot",
		"Murtaza Lightwala - Professional Photo for Business Profile",
		"Murtaza Lightwala - Stylish Portrait Image",
	];

	const [currentImageIndex, setCurrentImageIndex] = useState(0);
	const [transitionClass, setTransitionClass] = useState(
		"image-transition-main"
	);

	useEffect(() => {
		const interval = setInterval(() => {
			setTransitionClass("image-transition");
			setTimeout(() => {
				setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
				setTransitionClass("image-transition-main");
			}, 1000); // Duration of transition effect
		}, 5000); // Interval between image changes

		return () => clearInterval(interval);
		// eslint-disable-next-line
	}, []);
	return (
		<section
			id="hero-section"
			className="section section-started"
			style={{ textAlign: "left" }}
		>
			<div className="container">
				<article className="hero-started">
					<div className="slide">
						<img
							id="hero-image"
							src={`${process.env.PUBLIC_URL}/assets/images/profile/${images[currentImageIndex]}.webp`}
							alt={imagesAlt[currentImageIndex]}
							className={transitionClass}
						/>
						<span className="circle circle-1">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="749px"
								height="375px"
							>
								<path
									fillRule="evenodd"
									fill="#ff8059"
									d="M749.000,0.000 C749.000,206.786 581.459,374.514 374.608,374.514 C167.758,374.514 -0.000,206.786 -0.000,0.000 "
								/>
							</svg>
						</span>
						<span className="circle circle-2">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="416px"
								height="209px"
							>
								<path
									fillRule="evenodd"
									fill="#3aafc9"
									d="M-0.000,209.000 C-0.000,94.252 93.051,0.745 207.835,0.745 C322.619,0.745 416.000,94.252 416.000,209.000 "
								/>
							</svg>
						</span>
						<span className="circle circle-3">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="416px"
								height="209px"
							>
								<path
									fillRule="evenodd"
									fill="#b9d1e4"
									d="M-0.000,209.000 C-0.000,94.252 93.051,0.745 207.835,0.745 C322.619,0.745 416.000,94.252 416.000,209.000 "
								/>
							</svg>
						</span>
						<span className="circle circle-4">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="121px"
								height="241px"
							>
								<path
									fillRule="evenodd"
									fill="#676cdb"
									d="M0.000,0.000 C66.624,0.000 120.402,54.096 120.402,120.733 C120.402,187.371 66.624,241.000 0.000,241.000 "
								/>
							</svg>
						</span>
						<span className="circle circle-5">
							<svg
								xmlns="http://www.w3.org/2000/svg"
								width="232px"
								height="117px"
							>
								<path
									fillRule="evenodd"
									fill="rgb(255, 208, 65)"
									d="M232.000,0.000 C232.000,64.151 180.376,116.580 116.238,116.580 C52.100,116.580 0.000,64.151 0.000,0.000 "
								/>
							</svg>
						</span>
					</div>
					<div className="content">
						<header className="titles">
							<Fade direction="up" cascade={true} damping={.5} triggerOnce>
								<h2
									className="subtitle"
									style={{
										display: "block",
										marginBlockStart: 0,
										marginBlockWnd: 0,
										marginInlineStart: 0,
										marginInlineEnd: 0,
										fontWeight: "normal",
										unicodeBidi: "normal",
										fontFamily: "unset",
									}}
								>
									Team Lead
								</h2>
								<h1 className="title">
									Murtaza <br />
									Lightwala
								</h1>
							</Fade>
						</header>
						<section className="description">
							<Fade direction="up" delay={1200} triggerOnce>
								<p>
									As a <strong>Visionary</strong>, I strive to create software
									that transcends conventional boundaries. My passion is
									crafting intuitive and impactful solutions that revolutionize
									user interactions with technology, regardless of their
									technical expertise.
								</p>
							</Fade>
							<SocialLinks />
						</section>
					</div>
					<aside className="info-list">
						<Fade direction="up" cascade={true} damping={1} triggerOnce>
							<ul>
								<li>
									<strong>Location:</strong> Indore, India
								</li>
								<li>
									<strong>Experience:</strong> Over 4.6 Years
								</li>
								<li>
									<strong>Persona:</strong> Visionary
								</li>
							</ul>
						</Fade>
					</aside>
				</article>
			</div>
		</section>
	);
};

export default HeroSection;
